export class LangSwitcherController {
    static init(): void {
        document.querySelectorAll<HTMLElement>("[data-lang-switcher]").forEach((el) => {
            const btn = el.querySelector<HTMLElement>(".lang-switcher__btn");
            const dropdown = el.querySelector<HTMLElement>(".lang-switcher__dropdown");
            if (!btn || !dropdown) return;

            btn.addEventListener("click", (e) => {
                e.stopPropagation();
                const isOpen = btn.getAttribute("aria-expanded") === "true";
                btn.setAttribute("aria-expanded", String(!isOpen));
                el.classList.toggle("is-open", !isOpen);
            });

            document.addEventListener("click", () => {
                btn.setAttribute("aria-expanded", "false");
                el.classList.remove("is-open");
            });

            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                    btn.setAttribute("aria-expanded", "false");
                    el.classList.remove("is-open");
                }
            });
        });
    }
}
